import tippy, { type Instance, type Placement } from 'tippy.js'
import 'tippy.js/dist/tippy.css'

const instances = new WeakMap<Element, Instance>()

function popoverPlacement(preferred: Placement = 'right'): Placement {
  if (typeof document !== 'undefined' && document.documentElement.dir === 'rtl') {
    return preferred === 'right' ? 'left' : preferred === 'left' ? 'right' : preferred
  }
  return preferred
}

/** Tippy popover как в Vristo Alpine `$popovers(message, placement)`. */
export function showPopover(
  el: Element,
  message: string,
  placement: Placement = 'right',
  theme = 'info',
): Instance {
  const existing = instances.get(el)
  if (existing) {
    if (existing.state.isVisible) {
      existing.hide()
      return existing
    }
    existing.setContent(message)
    existing.setProps({ placement: popoverPlacement(placement), theme })
    existing.show()
    return existing
  }

  const instance = tippy(el, {
    content: message,
    placement: popoverPlacement(placement),
    interactive: true,
    allowHTML: true,
    theme,
    trigger: 'manual',
    hideOnClick: true,
    appendTo: () => document.body,
  })
  instances.set(el, instance)
  instance.show()
  return instance
}

export function destroyPopover(el: Element): void {
  const existing = instances.get(el)
  if (!existing) return
  existing.destroy()
  instances.delete(el)
}
